import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { map } from 'lodash'

import { translate, utils } from 'parking-react-common'

import { ui, routing, parkingLots, activeSessions, filters } from '../redux'

import List from '../components/List'
import Button from '../components/Button'
import PrivilegeLabel from '../components/PrivilegeLabel'
import YesNoLabel from '../components/YesNoLabel'

const ParkingLotsList = ({ dataURL, dataSelector, t }) => {
    const columns = [
        {
            key   : 'name',
            title : t('Name')
        },
        {
            key    : 'type',
            title  : t('Type'),
            render : ({ cellData }) => utils.label(`parking-lots.type.${cellData}`)
        },
        {
            key   : 'spots_total',
            title : t('Total Spots')
        },
        {
            key   : 'activeSessions',
            title : t('Active Sessions')
        },
        {
            key   : 'recent_sessions',
            title : t('Last 24H sessions')
        },
        {
            key    : 'enabled',
            title  : t('Enabled'),
            render : ({ cellData }) => (<YesNoLabel value={ cellData } />) // eslint-disable-line react/prop-types
        },
        {
            key    : 'published',
            title  : t('Published'),
            render : ({ cellData }) => (<YesNoLabel value={ cellData } />) // eslint-disable-line react/prop-types
        },
        {
            key    : 'privileges',
            title  : t('Privileges'),
            render : ({ cellData }) => map(cellData, (privilege) => (
                <PrivilegeLabel
                    type={ privilege }
                    key={ privilege }
                />
            ))
        },
        {
            key   : 'extra.total',
            title : t('Total')
        }
    ]

    const searchKeys = ['name', 'type']
    const filterKeys = {
        most_recent_session_moment: filters.TYPES.dateRange
    }

    return (
        <List
            title={ <Link to={ routing.routeFor('parkingLots') }>{ t('Parking Lots') }</Link> }
            tools={ (
                <Button
                    intent={ ui.INTENT.success }
                    size={ ui.SIZE.large }
                    icon="fa/plus"
                    label={ t('Add') }
                    link={ routing.routeFor('parkingLots', { action: 'add' }) }
                />
            ) }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ searchKeys }
            filterKeys={ filterKeys }
            onRowClick={ ({ rowData }) => routing.push(
                routing.routeFor('parkingLots', { id: rowData.id })
            ) }
        />
    )
}

ParkingLotsList.propTypes = {
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string
}

ParkingLotsList.defaultProps = {
    dataSelector : parkingLots.getForCurrentUser,
    dataURL      : 'parkingLots'
}

function mapStateToProps(state, ownProps) {
    const dataSelector = (state) => {
        const items = ownProps.dataSelector(state)
        return utils.enhance(items, {
            activeSessions : ({ url }) => activeSessions.getForParkingLot(url)(state),
            privileges     : ({ url }) => parkingLots.getCurrentUserPrivileges(url)(state)
        })
    }

    return {
        dataSelector
    }
}

export default compose(
    translate(),
    connect(mapStateToProps)
)(ParkingLotsList)
